import openSocket from 'socket.io-client';

export const socket = openSocket(process.env.NODE_ENV === "development" ? process.env.REACT_APP_SOCKET_URL_DEVELOPMENT : process.env.REACT_APP_SOCKET_URL_PRODUCTION, process.env.NODE_ENV === "development" && { transports : ['websocket'] });
